"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreesStateProvider = exports.useTreesState = void 0;
const unstated_next_1 = require("unstated-next");
const react_1 = require("react");
const useTreesStateContainer = unstated_next_1.createContainer(() => {
    const [tree, setTree] = react_1.useState({ nodes: [] });
    const [libraryTree, setLibraryTree] = react_1.useState({ nodes: [] });
    const [snapshots, setSnapshots] = react_1.useState([]);
    const [undos, setUndos] = react_1.useState([]);
    const [selectedNode, setSelectedNode] = react_1.useState();
    const selectedNodeRef = react_1.useRef(null);
    const [readonly, setReadonly] = react_1.useState(false);
    const [isTreeInitial, setIsTreeInitial] = react_1.useState(true);
    const [position, setPosition] = react_1.useState();
    const past = () => {
        const p = snapshots.pop();
        if (p) {
            setUndos((u) => [...u, p]);
            setSnapshots([...snapshots]);
            return p;
        }
    };
    const future = () => {
        const p = undos.pop();
        if (p) {
            setUndos([...undos]);
            setSnapshots((s) => [...s, p]);
            return p;
        }
    };
    const relatedToSelected = react_1.useCallback(() => {
        var _a;
        const node = tree.nodes.find((n) => n.name === (selectedNode === null || selectedNode === void 0 ? void 0 : selectedNode.name) && n.data.type === selectedNode.data.type) ||
            libraryTree.nodes.find((n) => n.name === (selectedNode === null || selectedNode === void 0 ? void 0 : selectedNode.name) && n.data.type === selectedNode.data.type);
        if (node) {
            return (_a = node.args) === null || _a === void 0 ? void 0 : _a.map((a) => a.type.name);
        }
    }, [selectedNode]);
    return {
        tree,
        setTree,
        libraryTree,
        setLibraryTree,
        snapshots,
        setSnapshots,
        selectedNode,
        setSelectedNode,
        selectedNodeRef,
        position,
        setPosition,
        past,
        undos,
        setUndos,
        future,
        relatedToSelected,
        readonly,
        setReadonly,
        isTreeInitial,
        setIsTreeInitial,
    };
});
exports.useTreesState = useTreesStateContainer.useContainer;
exports.TreesStateProvider = useTreesStateContainer.Provider;
